<template>
    <el-config-provider :locale="locale" :empty-values="['', undefined, null]">
        <router-view />
    </el-config-provider>
</template>

<script setup>
import { initTccc } from '@/utils/Tccc'
import useSettingsStore from "@/store/modules/settings";
import { handleThemeStyle } from "@/utils/theme";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
// 解决日期时间国际化问题
import "dayjs/locale/zh-cn";
const locale = ref(zhCn); //使用中文
onMounted(() => {
    initTccc(true)
    nextTick(() => {
        //初始化主题样式
        handleThemeStyle(useSettingsStore().theme);
    });
});
</script>
